module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-in-this-price-image-2-c4286084cf3446b95055b3b449425b21.png";